export default __webpack_public_path__ + "static/InterDisplay-Regular-530ad7d11f71f543f85cb3c0b1a6cb94.woff2";